import axios from 'axios'
import Vue from 'vue'
/**
 * Metodo que busca las categorias de los tickets
 * @param {*} context 
 * @param {*} payload 
 */
export async function fetchModulos(context, payload){
    try{
        let url = "api/getmodulos"//direccion de la api
        context.commit('setLoading',true,{root:true})//lanzamiento del loading
        let values = new FormData()
        values.append('token','RUMwelVSanJ4OG0xdGI1dVpBVFg=')
        let response = await Vue.axios({
            method: 'POST',
            url: url,
            data: values
        })
        
        context.commit('setModulos', response.data)

    }catch(error){
        context.commit('moduloError',error)
    }finally{
        context.commit('setLoading',false,{root:true})
    }

}
